import { MetricType } from '../utils/metric-type'

export default class ScrollFixationDetector {
  constructor(metricsCollector, maxdist = 300, mindur = 1000) {
    this.maxdist = maxdist
    this.mindur = mindur

    this.TotalDuration = 0 // Initialize TotalDuration to zero
    this.lastProcessedIndex = 0 // Keeps track of the last processed scroll position

    this.metricsCollector = metricsCollector

    if (localStorage.scrollFixationDuration) this.mindur = localStorage.scrollFixationDuration
    if (localStorage.scrollFixationDistance) this.maxdist = localStorage.scrollFixationDistance

    this.resetData()
  }

  fixationDetection() {
    let si = 0
    let totalDuration = 0
    let count = 0

    for (let i = 1; i < this.scrollPositions.length; i++) {
      let distance = Math.abs(this.scrollPositions[i] - this.scrollPositions[i - 1])

      if (distance > this.maxdist) {
        const duration = this.time[i] - this.time[i - 1]
        if (duration > this.mindur) {
          totalDuration += duration
          count += 1
        }
      }
    }

    return { fixationCount: count, fixationDuration: totalDuration }
  }

  resetData() {
    this.scrollPositions = []
    this.time = []
  }

  listenToScrollEvents() {
    document.addEventListener('scrollend', () => {
      this.scrollPositions.push(window.scrollY)
      const date = Date.now()
      this.time.push(date)

      const { fixationCount, fixationDuration } = this.fixationDetection()
      console.info(`[SCROLL_FIXATION] Date: ${date}, Count: ${fixationCount}, Duration: ${fixationDuration}`)

      this.metricsCollector.pushMetric('scroll_fixation_duration', MetricType.Max, Math.floor(fixationDuration / 1000))
      this.metricsCollector.pushMetric('scroll_fixation_count', MetricType.Max, fixationCount)
    })
  }
}
